var exports = {
  "H": "CodespacesSkeletonWrapper__BVZt1D",
  "q": "SkeletonLoaderWrapper__EHjy8M",
};

module.exports = exports;
